import React from 'react';
import DocumentPlusIcon from '../../../shared/DocumentPlusIcon';
import { useBootstrapPopover } from '../hooks/useBootstrapPopover';
import { useLocalizer } from '../hooks/useLocalizer';

interface RequestMoreFilesButtonProps {
    onClick: () => void;
}

export const RequestMoreFilesButton: React.FC<RequestMoreFilesButtonProps> = ({ onClick }) => {
    const localize = useLocalizer();
    const title = localize('Fill in gaps with supplier input');
    const description = localize('Generate a gap report listing the missing required fields. Download the report or send it to the supplier by email to request additional documents.');
    const buttonRef = React.useRef<HTMLButtonElement | null>(null);

    useBootstrapPopover(buttonRef);

    return (
        <button
            ref={buttonRef}
            type="button"
            className="gap-summary-resolution-option"
            data-toggle="popover"
            data-container="body"
            data-placement="bottom"
            data-content={description}
            aria-label={`${title}. ${description}`}
            onClick={onClick}
        >
            <span className="gap-summary-resolution-icon">
                <DocumentPlusIcon className="gap-summary-document-plus-icon" />
            </span>
            <span className="gap-summary-resolution-copy">
                <strong>{title}</strong>
            </span>
            <span className="glyphicon glyphicon-arrow-right gap-summary-resolution-arrow" aria-hidden="true"></span>
        </button>
    );
};

export default RequestMoreFilesButton;
